module.exports = __webpack_public_path__ + "img/ic-chevron-right-white.143a14c5.svg";